import { SelectInput, useGetList, Loading } from "react-admin";
import { IfCanAccess } from "@react-admin/ra-rbac";

export const ProjectFilter = ({ source = "projectId" }: { source?: string }) => {
  const { data, isLoading, error } = useGetList("projectsMenu");
  if (isLoading) {
    return <Loading />;
  }
  if (error) {
    return null;
  }
  return (
    <IfCanAccess action="list" resource="projectsMenu">
      <SelectInput
        label="Entity"
        source={source}
        helperText={false}
        choices={(data || []).map((project) => ({
          id: project.id,
          name: project.name,
        }))}
      />
    </IfCanAccess>
  );
};
